import React from "react";

function TestPage() {
  return (
    <div style={{ padding: "50px", textAlign: "center" }}>
      <h1>Test Page Works!</h1>
      <p>If you can see this, the routing is working for new pages.</p>
      <p>Current URL: {window.location.pathname}</p>
      <p>Time: {new Date().toISOString()}</p>
      <hr />
      <h2>Navigation Test</h2>
      <p>Try these links:</p>
      <ul style={{ listStyle: "none", padding: 0 }}>
        <li>
          <a href="/">Home (works)</a>
        </li>
        <li>
          <a href="/features">Features (works)</a>
        </li>
        <li>
          <a href="/testpage">Test Page (this page)</a>
        </li>
        <li>
          <a href="/gettingstarted">Getting Started (broken)</a>
        </li>
        <li>
          <a href="/adminfeatures">Admin Features (broken)</a>
        </li>
      </ul>
    </div>
  );
}

export default TestPage;
